import { render, staticRenderFns } from "./MobileMoney.vue?vue&type=template&id=5ac762fc&scoped=true&"
import script from "./MobileMoney.vue?vue&type=script&lang=js&"
export * from "./MobileMoney.vue?vue&type=script&lang=js&"
import style0 from "./MobileMoney.vue?vue&type=style&index=0&id=5ac762fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac762fc",
  null
  
)

export default component.exports